import { useAuth } from "./AuthProvider";

const Logout = () => {
    const auth = useAuth();
    auth.LogoutAction();
};

export default Logout;